/*****************************
*
* 企业端共用localStorage列表
* userName 登录用户名
* customerId 登录id
* customerName 登录企业名
* projectName 选择的项目名
* projectTime 选择的项目的创建时间
* customerRole 登录用户拥有的所有角色
* contractIds 选择的项目对应的合同id 格式：'123,423'
* 清除本地的数据: localStorage.clear();
*
* @lastUpdatedBy Zhao Wenjie at 2017年11月21日17:23:06
*****************************/

/**
 * 根据键获取localStorage值
 * @param  {String} key    [键]
 */
function get (key) {
  if (window.localStorage) {
    return localStorage.getItem(key)
  }
}
/**
 * 根据键清除localStorage值
 * @param  {String} key    [键]
 */
function remove (key) {
  if (window.localStorage) {
    return localStorage.removeItem(key)
  }
}
/**
 * 设置local
 * @param  {String}  key    [键]
 * @param  {String}  value  [值]
 */
function set (key, value) {
  if (window.localStorage) {
    localStorage.setItem(key, value)
  }
}

export default { set, get, remove }



// WEBPACK FOOTER //
// ./src/components/dcf/js/LocalStorageUtils.js